import { Component, Input } from '@angular/core';

@Component({
  selector: 're-progress-bar',
  templateUrl: './progress-bar.component.html',
  styleUrl: './progress-bar.component.css',
})
export class ProgressBarComponent {
  @Input() progress = 0;
  @Input() progress2 = 0;
  @Input() label = '';
}
